export const tutorialSelector = state => state.tutorial;

export const showTutorialSelector = state =>
  tutorialSelector(state).showTutorial;

export const tutorialCasesSelector = state => tutorialSelector(state).cases;

export const isCaseTutorialDisplayed = caseGuid => state =>
  tutorialSelector(state).cases?.includes(caseGuid);
